document.addEventListener('DOMContentLoaded', () => {
  const toggle = document.getElementById('SidebarToggle');
  const sidebar = document.getElementById('SidebarMenu');
  const overlay = document.querySelector('.custom-sidebar-overlay');
  const closeBtn = document.querySelector('.custom-sidebar__close');

  if (!toggle || !sidebar || !overlay) return;

  // Open sidebar
  toggle.addEventListener('click', () => {
    sidebar.classList.add('active');
    overlay.classList.add('active');
    document.body.style.overflow = 'hidden';
  });

  // Close sidebar
  function closeSidebar() {
    sidebar.classList.remove('active');
    overlay.classList.remove('active');
    document.body.style.overflow = '';
  }

  overlay.addEventListener('click', closeSidebar);
  closeBtn.addEventListener('click', closeSidebar);

  // Accordion
  document.querySelectorAll('.custom-sidebar__parent').forEach(btn => {
    btn.addEventListener('click', () => {
      const item = btn.closest('.custom-sidebar__item');
      item.classList.toggle('active');
    });
  });
});


(function () {

  let loading = false;

  function getNextLink() {
    const nextBtn = document.querySelector('#pagination-wrapper .pagination__item--prev');
    return nextBtn ? nextBtn.getAttribute('href') : null;
  }

  function hasPagination() {
    return document.querySelector('#pagination-wrapper .pagination');
  }

  function onScroll() {

    if (loading) return;
    if (!hasPagination()) return;

    const grid = document.querySelector('#product-grid');
    if (!grid) return;

    const gridBottom = grid.getBoundingClientRect().bottom;

    if (gridBottom - window.innerHeight < 200) {

      const nextUrl = getNextLink();
      if (!nextUrl) return;

      loading = true;

      const loader = document.getElementById('infinite-loader');
      if (loader) loader.style.display = 'block';

      fetch(nextUrl)
        .then(r => r.text())
        .then(html => {

          const doc = new DOMParser().parseFromString(html, 'text/html');

          const newItems = doc.querySelectorAll('#product-grid .grid__item');
          const newNext = doc.querySelector('#pagination-wrapper .pagination__item--prev');

          if (!newItems.length) {
            window.removeEventListener('scroll', onScroll);
            if (loader) loader.style.display = 'none';
            return;
          }

          newItems.forEach(el => grid.appendChild(el));

          // ⭐ update next link
          const currentNext = document.querySelector('#pagination-wrapper .pagination__item--prev');
          if (currentNext && newNext) {
            currentNext.setAttribute('href', newNext.getAttribute('href'));
          } else if (currentNext) {
            currentNext.remove();
          }

          loading = false;
          if (loader) loader.style.display = 'none';

        });

    }

  }

  function initInfinite() {

    loading = false;

    window.removeEventListener('scroll', onScroll);
    window.addEventListener('scroll', onScroll);

  }

  document.addEventListener('DOMContentLoaded', initInfinite);
  document.addEventListener('facets:updated', initInfinite);

})();

const track = document.querySelector(
    '.custom-hero-banner-holiday-information-text'
);

const originalContent = track ? track.innerHTML : '';

function duplicateContent() {
    if (!track) return;

    if (window.innerWidth <= 767) {
        if (!track.dataset.duplicated) {
            track.innerHTML += originalContent + originalContent;
            track.dataset.duplicated = 'true';
        }
    } else {
        // Restore original content on desktop
        track.innerHTML = originalContent;
        delete track.dataset.duplicated;
    }
}

document.addEventListener('DOMContentLoaded', duplicateContent);
window.addEventListener('resize', duplicateContent);

const bundle = document.querySelector('.bundle-products');

const count = bundle.querySelectorAll('label.bundle-item').length;

bundle.classList.toggle('has-four', count >= 4);
